import React, { useEffect, useState } from 'react';
import EfButton from '@elem/ui/ef-button';
import EfImg from '@elem/ui/ef-img';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import gtm from '@/utils/gtm';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';
import { useGlobal } from '@/utils/useGlobal';

const MemberDrainageBar: React.FC = () => {
    const router = useRouter();
    const { locale } = getLocal();
    const { getSystemTime } = useGlobal();
    const { _timer } = router.query;
    const [show, setShow] = useState<boolean>(false);
    const systemTime = getSystemTime();
    const { t } = useLang('shared.member_drainage');
    const startTime = new Date(`2025/04/01 15:00:00 GMT+8`).getTime();
    const endTime = new Date(`2025/04/23 15:00:00 GMT+8`).getTime();
    const handleClick = () => {
        router.push(`/${locale}/members-festival`);
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_join',
            button_name: 'Join Now',
        });
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (_timer) {
                if (new Date(`${_timer} GMT+8`).getTime() >= startTime && new Date(`${_timer} GMT+8`).getTime() < endTime) {
                    setShow(true);
                } else {
                    setShow(false);
                }
            } else {
                if (systemTime >= startTime && systemTime < endTime) {
                    setShow(true);
                } else {
                    setShow(false);
                }
            }
        }
    }, []);

    return (
        <div className={styles.MemberDrainageBar} style={show ? { display: 'block' } : {}}>
            <div className="bar-container" onClick={handleClick}>
                <EfImg
                    className="gift-bg"
                    pc="https://websiteoss.ecoflow.com/upload/image/1741938813828/bar-PC.jpg"
                    pad="https://websiteoss.ecoflow.com/upload/image/1741938813828/bar-PC.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1741938909382/bar-m.jpg"
                    alt=""
                ></EfImg>
                <div className="bar-content">
                    <h3 className="title">{t('bar_title')}</h3>
                    <p className="desc">{t('bar_desc1')}</p>
                    <p className="desc">{t('bar_desc2')}</p>
                    <EfButton type="buy_now" className="join-btn">
                        {t('bar_btn')}
                    </EfButton>
                </div>
            </div>
        </div>
    );
};

export default MemberDrainageBar;
